import React from "react";
import { PropTypes } from "prop-types";
import { PortalDetailedActivity } from "administration/analytics/components";
import { defaultTemplate } from "common/hoc";

function RegisteredUserDevicesActivityTemplate({ registeredUserDevicesActivityViewStore, t }) {
    return (
        <PortalDetailedActivity
            store={registeredUserDevicesActivityViewStore}
            activityLabel="Registered devices over period"
            totalLabel="Total # of registered devices"
            t={t}
        />
    );
}

RegisteredUserDevicesActivityTemplate.propTypes = {
    registeredUserDevicesActivityViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(RegisteredUserDevicesActivityTemplate);
